import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Tariff } from 'brain-data/model/tariff.model';

const TARIFFS_URL = `${environment.apiBaseUrl}/tariffs`;

@Injectable({ providedIn: 'root' })
export class TariffService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<Tariff[]> {
    return this.http.get<Tariff[]>(TARIFFS_URL);
  }
}
